import { render } from "./index.vue?vue&type=template&id=4bc6c581&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=4bc6c581&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=4bc6c581&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc6c581"]])

export default __exports__